import * as React from "react";

function SvgComponent(
  props: React.SVGProps<SVGSVGElement> & { color?: string }
) {
  const { height = 24, width = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9_32634)">
        <path
          d="M8.84625 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V5.25C2.25 4.85218 2.40804 4.47064 2.68934 4.18934C2.97064 3.90804 3.35218 3.75 3.75 3.75H12.75C13.1478 3.75 13.5294 3.90804 13.8107 4.18934C14.092 4.47064 14.25 4.85218 14.25 5.25V8.25"
          stroke="#707A8F"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 13.5C10.5 14.2956 10.8161 15.0587 11.3787 15.6213C11.9413 16.1839 12.7044 16.5 13.5 16.5C14.2956 16.5 15.0587 16.1839 15.6213 15.6213C16.1839 15.0587 16.5 14.2956 16.5 13.5C16.5 12.7044 16.1839 11.9413 15.6213 11.3787C15.0587 10.8161 14.2956 10.5 13.5 10.5C12.7044 10.5 11.9413 10.8161 11.3787 11.3787C10.8161 11.9413 10.5 12.7044 10.5 13.5Z"
          stroke="#707A8F"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 2.25V5.25"
          stroke="#707A8F"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 2.25V5.25"
          stroke="#707A8F"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.25 8.25H14.25"
          stroke="#707A8F"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5 12.3721V13.5001L14.25 14.2501"
          stroke="#707A8F"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9_32634">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgComponent;
